<template>

  <div class="card contain" style="border-radius: 5px; width: 95%; height: 650px; margin: auto;">
    <div style="width: 98%;">
      <h2 style="text-align: center"> Fare Rules </h2>
      <h3> </h3>
      <br />
      <div v-if="!rules.length">
        <b-loading :is-full-page="false" :active="true"></b-loading>
      </div>
      <div v-else>
        <div class="columns">
          <div class="column" v-for="i in size" :key="i">
            <b-collapse
                  class="card"
                  animation="slide"
                  v-for="(rule, index) of rules_adj.slice((i-1) * rules_adj.length/size, i*rules_adj.length / size)"
                  :key="index"
                  :open="isOpen == index + i * rules_adj.length/size"
                  @open="isOpen = index + i * rules_adj.length/size">
                  <div
                      slot="trigger" style=" height: 30px; "
                      slot-scope="props"
                      class="card-header"
                      role="button">
                      <p class="card-header-title" style="margin-bottom: 0px; font-size: 11px;">
                          {{ rule.name }}
                      </p>
                      <a class="card-header-icon">
                          <b-icon
                              :icon="props.open ? 'menu-up'  : 'menu-down'">
                          </b-icon>
                      </a>
                  </div>
                  <div class="card-content">
                      <div class="content" style="font-size: 10px; color: gray;">
                        {{ rule.description}}
                      </div>
                  </div>
              </b-collapse>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

    export default {
      name: 'FareRules',
      props: {
        journeys: Array
      },
      data: function () {
          return {
            isOpen: 0,
            rules: []
        }
      },
      methods: {
        async priceCheck(){
          var raw = {
            "stateful": true,
            "numberOfPassengers": 1,
            "journeys": this.journeys
        }

        this.$app.huddleLabsServerCall('amadeus/air/price', raw)
          .then(result => this.getRules(result.sessionKey))
        },
        async getRules(key) {
          // console.log(key)
          var raw = {
              "stateful": true,
              "sessionKey": key
          }


          this.$app.huddleLabsServerCall('amadeus/air/rules/check', raw)
            .then(result => this.rules = result.response.tariffInfo)
        },
        combineRules(rules){
          var rule;
          var result = "";
          for (rule of rules) {
            result = result + rule.freeText
          }
          return result
        }
    },
    mounted () {
      this.priceCheck()
    },
    computed: {
      size (){
        return 1
        // return Math.floor(this.rules_adj.length / 8)
      },
      rules_adj () {
        var new_rules = []
        for (var i = 0; i < this.rules.length; i++){
          var rule = {}
          rule.name = this.rules[i].fareRuleText[0].freeText.split(".")[1]
          rule.description = this.combineRules(this.rules[i].fareRuleText.slice(1))
          new_rules.push(rule)
        }
        return new_rules
        // return this.rules.slice(1, this.rules.length - 1)
      }

    }
  }

</script>


<style scoped>
.card-content{
    background-color: transparent;
    padding: 1.5rem;
    overflow-y: auto;
    max-height: 90px;
}

.contain {
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
}
.contain::-webkit-scrollbar { /* WebKit */
    /* width: 0;
    height: 0; */
}

.sect1 {
  /* border-style: solid;
  border-width: 0.5px;
  border-color: gray; */
  border-radius: 5px;
  padding: 2px;
}

</style>
